import React from 'react';
const blockName = 'preload-scores';
import EmptyMatchScores from './emptyMatchScores';
import { range, } from '../../../jsCore/utils/array';
const NUM_ROWS_IN_PRELOAD = 3;
export default function PreloadScores({}){
  const listClassNames = [`${ blockName }__list`, `${ blockName }__list--loading`].join(' ')
  const rows = range(NUM_ROWS_IN_PRELOAD)
    .map((_, i)=> <EmptyMatchScores blockName={ blockName } key={ i }/>);
  return (
    <div className={ blockName }>
      <div className={ `${ blockName }__wrapper` }>
        <h2 className={ `${ blockName }__header` }/>
        <ul className={ listClassNames }>
          { rows }
        </ul>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/preloadScores.js